import { SocialNumber } from "src/app/ui/models/domains/pbm/social-number.model";

export enum FinancialStatementSearchType {
  CPF = 1,
  NAME = 2,
  CARD = 3,
}

export interface FinancialStatementSearchValidationResult {
  isValid: boolean;
  sanitizedValue: string;
  errorMessage?: string;
}

export class FinancialStatementSearchValidator {
  private static readonly CARD_LENGTH = 17;

  static validate(searchType: number, value: string): FinancialStatementSearchValidationResult {
    const sanitizedValue = this.sanitize(searchType, value);

    if (searchType === FinancialStatementSearchType.CPF) {
      if (!SocialNumber.isValid(value)) {
        return {
          isValid: false,
          sanitizedValue,
          errorMessage: "CPF inválido. Informe os 11 dígitos.",
        };
      }
    }

    if (searchType === FinancialStatementSearchType.CARD) {
      if (sanitizedValue.length !== this.CARD_LENGTH) {
        return {
          isValid: false,
          sanitizedValue,
          errorMessage: `Número do cartão inválido. Informe os ${this.CARD_LENGTH} dígitos.`,
        };
      }
    }

    return {
      isValid: true,
      sanitizedValue,
    };
  }

  static sanitize(searchType: number, value: string): string {
    if (!value) {
      return "";
    }

    if (searchType === FinancialStatementSearchType.CPF || searchType === FinancialStatementSearchType.CARD) {
      return value.replace(/[^\d]/g, "");
    }

    return value.trim();
  }
}
